import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledSystem } from "./systems.styled";
import { SEARCH_TABLE_STYLE } from "./systems.constants";
import { useSystemOptions } from "./systems.data";
import { useSystemStructures } from "./useSystemStructures";
import { useSystemsBrowse } from "./useSystemsBrowse";
import { useSystemsNavigation } from "./useSystemsNavigation";

function Systems() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useSystemStructures();
  const browse = useSystemsBrowse();
  const navigation = useSystemsNavigation();
  const systemOptions = useSystemOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledSystem>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={systemOptions}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledSystem>
  );
}

export default Systems;
